import { useMutationHandler } from "@sinch/hooks/useMutationHandler";

import {
  CreateMessageTemplateMutation,
  CreateMessageTemplateMutationVariables,
  EditMessageTemplateMutation,
  EditMessageTemplateMutationVariables,
} from "./queries.types";
import { CreateMessageTemplate, EditMessageTemplate } from "@sinch/components/application/Messages/queries.graphql";

/**
 * Hook for managing message template creation and updates.
 * Provides methods for creating and updating message templates, with loading states.
 */
export const useMessageTemplate = () => {
  const [update, { loading: creating }] = useMutationHandler<
    EditMessageTemplateMutation,
    EditMessageTemplateMutationVariables
  >(EditMessageTemplate);

  const [create, { loading: updating }] = useMutationHandler<
    CreateMessageTemplateMutation,
    CreateMessageTemplateMutationVariables
  >(CreateMessageTemplate);

  return {
    create,
    update,
    loading: creating || updating,
  };
};
